import { render } from "./Accreditations.vue?vue&type=template&id=42ed55f3"
import script from "./Accreditations.vue?vue&type=script&lang=js"
export * from "./Accreditations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__